import { toTimestamp } from '../utils/addWebSocketToReplication'
import { createReplication } from './createReplication'
import type { SubscriptionCollection } from '../index'

/**
 * Setup replication for subscriptions
 * Note: Subscriptions are workspace-level
 */
export const setupSubscriptionReplication = (
  collection: SubscriptionCollection,
  envId: string,
) =>
  createReplication({
    entityName: 'subscriptions',
    displayName: 'Subscription',
    collection,
    envId,
    mapFromServer: (doc) => ({
      id: doc.id,
      envId: doc.envId ?? envId,
      planId: doc.planId,
      status: doc.status,
      trialStartDate: doc.trialStartDate,
      trialEndDate: doc.trialEndDate,
      currentPeriodStart: toTimestamp(doc.currentPeriodStart) ?? new Date(doc.currentPeriodStart).getTime(),
      currentPeriodEnd: toTimestamp(doc.currentPeriodEnd) ?? new Date(doc.currentPeriodEnd).getTime(),
      billingInterval: doc.billingInterval,
      canceledAt: doc.canceledAt,
      cancelAtPeriodEnd: doc.cancelAtPeriodEnd || false,
      stripeCustomerId: doc.stripeCustomerId ?? null,
      stripeSubscriptionId: doc.stripeSubscriptionId ?? null,
      paddleCustomerId: doc.paddleCustomerId ?? null,
      paddleSubscriptionId: doc.paddleSubscriptionId ?? null,
      billingProvider: doc.billingProvider ?? 'stripe',
      billingEmail: doc.billingEmail,
      isDeleted: doc.isDeleted || false,
      createdOn: toTimestamp(doc.createdOn) ?? new Date(doc.createdOn).getTime(),
      createdBy: doc.createdBy,
      updatedOn: toTimestamp(doc.updatedOn) ?? new Date(doc.updatedOn).getTime(),
      updatedBy: doc.updatedBy,
      deletedOn: doc.deletedOn ? (toTimestamp(doc.deletedOn) ?? new Date(doc.deletedOn).getTime()) : null,
      deletedBy: doc.deletedBy,
    }),
  })
